import { ComponentBootstrap } from '@demant/wdh-react-bootstrap';
import BlogPostApp from './react-blog-post';
var ReactBlogPost = new ComponentBootstrap('blog');
ReactBlogPost.reactApp = BlogPostApp;
ReactBlogPost.run();